/**
 * @description initializer
 * @returns returns
 */
 export const initializer: () => () => Promise<any> = (): () => Promise<any> => {
  return (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        // tslint:disable-next-line: no-string-literal
        if (window['appEnv']) {
          // tslint:disable-next-line: no-string-literal
          // guardamos en environment donde queremos
          // const win: any = window;
          // const env = win.appEnv;
        }
        resolve = (typeof resolve === 'function') ? resolve : () => {};
        resolve(null);
      } catch (error) {
        reject = (typeof reject === 'function') ? reject : () => {};
        reject(error);
      }
    });
  };
};
